import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Spinner, Button, Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { InvoiceService } from "../../Common/Services/InvoiceService";
import { Utils } from "../../Common/Utilis";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import createDOMPurify from "dompurify";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
//import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
//import {InvoicePaymentslideout}  from './InvoicePaymentslideout';
import  InvoiceEntryslideout  from '../Purchasing/InvoiceEntryslideout';
import  Receivableslideout  from './Receivableslideout';
import  DepositSlideout  from '../Transaction/DepositSlideout';
import  WithdrawalSlideout  from '../Transaction/WithdrawalSlideout';
import TransferSlideout  from '../Transaction/TransferSlideout';
import  JournalSlideout from '../Transaction/JournalSlideout';
import  InvoiceSlideout  from '../Transaction/InvoiceSlideout';
import DateRange from '../../Common/Components/DateRange';
import { InvoiceCheckSlideout } from "./InvoiceCheckSlideout";

const { SearchBar ,ClearSearchButton } = Search;

const DOMPurify = createDOMPurify(window);

 class Register extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.bindfilter = this.bindfilter.bind(this);
    // const { bankId, bankName } = this.props.location.state || {};
    const bankId = parseInt(localStorage.getItem('selectedBankId') || '0', 10);
    this.state = {
      selectedbankid: bankId,
      bankname: "Select",
      openDeposit: false,
      paymenttype: "",
      footershow: false,
      selectedRows: [],
      invoiceTotal: 0,
      isstatus: true,
      isinvoicestatus:true,
      isorderdate: true,
      iscustomername: true,
      iscustomercode: true,
      iscustomerpo: true,
      ispayment: true,
      isdeposit: true,
      isinvoiceno:true,
      isinvoicedate:true,
      htmlItem: [],
      bankList: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      invoiceListPaid: [],
      invoiceListPaidPaid: [],
      products: [],
      invoiceId: 0,
      orderIds: [],
      selectedcolumn: "All",
      selectOptions: [
        { id: 'All', name: 'All' },
        { id: 'Ck No', name: 'Ck No' },
        { id: 'Code', name: 'Code' },
        { id: 'Name', name: 'Name' },
        { id: 'Date', name: 'Date' },
        { id: 'Invoice No', name: 'Invoice No' },
        { id: 'Invoice Date', name: 'Invoice Date' },
        { id: 'Invoice Status', name: 'Invoice Status' },
        // { id: 'Payment', name: 'Payment' },
        // { id: 'Deposit', name: 'Deposit' },

      ],
      formData: {
        bankId: bankId,
        InvoiceIds: [],
        UnApprovedInvoiceIds: []
      }
    };


  }


  componentDidMount() {
    this.getbankList();
  }

  componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId ) {
         this.setState({selectedbankid:0},()=>{
         this.getbankList();
         });
          
        }
      }



  // getbankList = () => {
  //   let requestlist = { ...this.state.requestlist };
  //   InvoiceService.GetBankMaster(requestlist)
  //     .then(async (result: any | null) => {
  //       if (result != null) {
  //         let tempBankList: any = [];
  //         result.forEach((element) => {
  //           let item: any = {};

  //           item.id = element.id;
  //           item.name = element.bankName;
  //           tempBankList.push(item);
  //         });
  //         this.setState({ bankList: tempBankList }, () => {
  //           //this.bindfilter();
  //           const {formData} = this.state;
  //           formData.bankId = this.state.selectedbankid==undefined ? tempBankList[0].id : this.state.selectedbankid;
  //           this.getInvoiceListPaid(this.state.selectedbankid==undefined ? tempBankList[0].id : this.state.selectedbankid);
  //         debugger;
  //           let bankid = this.state.bankList.filter((x) => x.id == this.state.selectedbankid==undefined ? tempBankList[0].id : this.state.selectedbankid);
  //           let bankname = bankid.length > 0 ? bankid[0].name : "";

  //           this.setState({ bankname: bankname , formData});
  //         });
  //       }
  //       resolve();
  //     })
  //     .catch((err: any) => {
  //       toast.error(`Server Error, ${err}`);
  //       reject();
  //     });
  // };

  getbankList = () => {
    let requestlist = { ...this.state.requestlist };
    InvoiceService.GetBankMaster(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
          let tempBankList: any = [];
          result.forEach((element) => {
            tempBankList.push({ id: element.id, name: element.nickName + '-' + element.lastAccountNo.slice(-4) ,isShared:!!element.sharingid,isprimary: element.isprimary});
          });

          this.setState({ bankList: [] }, () => {
            this.setState({ bankList: tempBankList });
            const { formData } = this.state;
            // let selectedBankId = this.state.selectedbankid ?? (tempBankList.length > 0 ? tempBankList[0].id : null);
            // let selectedBankId = (tempBankList.length > 0 ? tempBankList[0].id : this.state.selectedbankid);
            // let selectedBankId = this.state.selectedbankid ? this.state.selectedbankid : (tempBankList.length > 0 ? tempBankList[0].id : 0);
            const selectedBankId = this.state.selectedbankid || tempBankList.find(b => b.isprimary)?.id || tempBankList[0]?.id || 0;


            formData.bankId = selectedBankId;
            localStorage.setItem('selectedBankId', selectedBankId);

            this.getInvoiceListPaid(selectedBankId);

            // Get selected bank name properly
            let selectedBank = tempBankList.find((x) => x.id === selectedBankId);
            let bankname = selectedBank ? selectedBank.name : "";

            this.setState({ bankname, formData });
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getInvoiceListPaid = (id) => {
    let requestlist = { ...this.state.requestlist };
    requestlist.isApproved = 1;
    requestlist.Bankid = id;
    requestlist.startDate = this.state.startDate;
    requestlist.endDate = this.state.endDate;
    requestlist.selectedOption = this.state.selectedOption;
    InvoiceService.GetRegisterBank(requestlist)
      .then(async (result: any | null) => {

        if (result != null) {
          console.log(result);
          this.setState({ invoiceListPaidPaid: result, selectedRows: [], footershow: false }, () => {
            this.bindfilter();
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  showslideout = () => {
    this.setState({ showSlideout: true, isSpinner: false, });
  };

  showInvoiceSlideout = () => {

    this.setState({ showInvoiceSlideout: true, isSpinner: false, orderIds: [], invoiceId: 0 });
  };





  closeSlideOut = () => {

    this.getInvoiceListPaid(this.state.formData.bankId);
    this.setState({ showSlideout: false, isSpinner: false, });
  };

  closeInvoiceSlideOut = () => {
    this.setState({ showInvoiceSlideout: false, showReceivableslideout: false, isSpinner: false, });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  closeDepositslideout = () => {
    this.setState({ openDeposit: false, transactionId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  closeWithdrawalslideout = () => {
    this.setState({ openWithdrawal: false, transactionId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  closeTransferslideout = () => {
    this.setState({ openTransfer: false, transferId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  closeInvoiceslideout = () => {
    this.setState({ showInvoice: false, transactionId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  closeJournalslideout = () => {
    this.setState({ openJournal: false, transactionId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  rowEvents = {

    onClick: (e: any, row: any, rowIndex: any) => {
      if (e.target.tagName !== 'BUTTON') {

        this.setState({
          showInvoiceSlideout: (row.entryType == "V"),
          showReceivableslideout: (row.entryType == "C" && row.invoiceNo),
          showInvoice: (row.entryType == "I"),
          orderid: row.orderId,
          invoiceId: row.invoiceId,
          isSpinner: false,
        });
      }

    },
  };

  rowEvents1 = {
    onClick: (e: any, row: any, rowIndex: any) => {
      console.log("open---", row);
      debugger;
      if (e.target.tagName !== 'BUTTON') {
        if (row.entryType == "C" && row.invoiceId && row.invoiceNo == "") {
          this.setState({
            openDeposit: true,
            transactionId: row.invoiceId,
            isSpinner: false,
          });
        }

        else if (row.entryType == "W" && row.invoiceId && row.invoiceNo == "") {
          this.setState({
            openWithdrawal: true,
            transactionId: row.invoiceId,
            isSpinner: false,
          });
        } else if (row.entryType == "T" || row.entryType == "TD") {
          this.setState({
            openTransfer: true,
            transferId: row.invoiceId,
            isSpinner: false,
          });
        }
        else if (row.entryType == "I" && row.paymentMethod === "ACH") {
          this.setState({
            showInvoice: true,
            invoiceId: row.invoiceId,
            isSpinner: false,
          });
        }
        else if (row.entryType == "I" && row.paymentMethod === "Check") {

          debugger;
          const filteredInvoices = this.state.invoiceListPaidPaid.filter(
            (x) =>
              x.ckno === row.ckno &&
              x.rowType === 2
          );

          // Group by InvoiceID and count occurrences
          const invoiceCountMap: Record<string, number> = filteredInvoices.reduce(
            (acc, invoice) => {
              acc[invoice.invoiceId] = (acc[invoice.invoiceId] || 0) + 1;
              return acc;
            },
            {} as Record<string, number>
          );
          const totalInvoiceCount = Object.values(invoiceCountMap).reduce((sum, count) => sum + count, 0);
          debugger;

          if (totalInvoiceCount == 1) {
            const singleInvoiceId = Object.keys(invoiceCountMap)[0];
            this.setState({
              showInvoice: true,
              invoiceId: singleInvoiceId,
              isSpinner: false,
            });
          }    
          else {
            this.setState({
              showInvoiceCheck: true,
              ckno:row.ckno.match(/\d+/)?.[0],
              bankid: row.bankid,
              series: row.series,
              ckdate: row.payDate,
              invoiceId: row.invoiceId,
              isSpinner: false,
            });
          }
        }
        else if (row.entryType == "J") {
          this.setState({
            openJournal: true,
            transactionId: row.invoiceId,
            isSpinner: false,
          });
        }

        // else if(row.entryType=="V"){
        //   this.setState({
        //     showInvoiceSlideout: true,
        //      orderid: row.orderId,
        //      invoiceId: row.invoiceId,
        //     isSpinner: false,
        //   });         
        // }
      }

    },
  };

  bindfilter = () => {
    let selectOptions = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.selectOptions))
    );

    this.setState({ selectOptions: selectOptions });

  };

  handleDateRangeChange = (updatedStartDate: Date | null, updatedEndDate: Date | null, updatedSelectedOption: string | null) => {
    let formData = { ...this.state.formData };
    formData.searchEndDate = updatedEndDate;
    formData.searchStartDate = updatedStartDate;

    this.setState({
      formData: formData,
      startDate: updatedStartDate,
      endDate: updatedEndDate,
      selectedOption: updatedSelectedOption,
    }, () => {
      if (this.state.selectedOption == "Date Range") { 
        this.setState({IsDateRange:true});
      }
      else {
        this.setState({IsDateRange:false});
        this.getInvoiceListPaid(this.state.formData.bankId);
      }
    });
  };

  handleSelectedItem1 = (control: any, id: any) => {
    let searcResult1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );



    let chkckno = id == "Ck No" ? true : false;
    let chkcode = id == "Code" ? true : false;
    let chkname = id == "Name" ? true : false;
    let chkdate = id == "Date" ? true : false;
    let chkpayment = id == "Payment" ? true : false;
    let chkdeposit = id == "Deposit" ? true : false;
    let isPayment = id == "Payment" ? true : false;
    let isinvoiceno = id == "Invoice No" ? true : false;
    let isinvoicedate = id == "Invoice Date" ? true : false;
    let isinvoicestatus = id == "Invoice Status" ? true : false;

    if (id == "All") {
      chkckno = true;
      chkcode = true;
      chkname = true;
      chkdate = true;
      chkpayment = true;
      chkdeposit = true;
      isPayment = true;
      isinvoiceno = true;
      isinvoicedate = true;
      isinvoicestatus = true;
    }


    this.setState({
      searcResult: [], selectedcolumn: id, isckno: chkckno,ispayment:isPayment, isdate: chkdate,
      isname: chkname, iscode: chkcode, isPayment: chkpayment,isinvoicestatus, isdeposit: chkdeposit,isinvoiceno,isinvoicedate
    },
      () => {
        this.setState({ searcResult: searcResult1 });

      }


    );

  };









  genratePDFPrintPreview = (checkno, series, ckdate, bankid) => {


    let invoiceListPaid = this.state.invoiceListPaid;

    if (invoiceListPaid.length > 0) {
      let request: any = {};

      request.bankid = bankid;
      request.CheckType = "I";
      request.pvrno = 0;
      request.CheckNo = checkno;
      request.Checkdate = ckdate;
      request.Downloadcopy = "";
      request.Series = series;
      request.isCopyCheck = "Not";
      request.browserName = "Chrome";
      request.vid = 0;
      //request.aid = 0;
      request.Uniquenos = "";
      InvoiceService.PrintActualCheck(request)
        .then(async (result: any | null) => {

          this.setState({ IsPrinted: true });
          resolve();
        })
        .catch((error) => {
          toast.error("Something went wrong. " + error, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          reject();
        });
    }

  };


  moreOptions = (eventKey: any) => {
    if (eventKey == "Print") {
      this.printItem();
    } else if (eventKey == "deposit") {
      this.setState({ openDeposit: true });
    } else if (eventKey == "withdrawal") {
      this.setState({ openWithdrawal: true });
    } else if (eventKey == "transfer") {
      this.setState({ openTransfer: true });
    } else if (eventKey == "reconcilation") {
      this.props.history.push('/Reconcile');
    }

  };

  printItem = () => {

    let request: any = {};
    request.isApproved = 1;
    request.search = $('#search-bar-0').val();
    request.Bankid = this.state.formData.bankId;
    request.startDate = this.state.startDate;
    request.endDate = this.state.endDate;
    request.selectedOption = this.state.selectedOption;
    this.setState({ isSpinner: true });

    InvoiceService.DownloadRegisterPDF(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false, });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ isSpinner: false, });
      });
  };


  handleSearch = () => {
    this.getInvoiceListPaid(this.state.formData.bankId);
  };

  handleSelectedItem2 = (control: any, id: any) => {
    let formData = { ...this.state.formData };

    if (control == 1) {
      formData.paymentMethod = id;
      this.setState({ formData });
    } else if (control == 2) {
      let bankid = this.state.bankList.filter((x) => x.id == id);
      let bankname = bankid.length > 0 ? bankid[0].name : "";
      formData.bankId = id;
      localStorage.setItem('selectedBankId', id);
      this.setState({
        formData, bankname


      }
        , () =>
          this.getInvoiceListPaid(id)
      )

        ;
    } else if (control == 3) {
      formData.accountingPeriod = id;
      this.setState({ formData });
    }
  };

  printConfirmation(checkno, series, ckdate, bankid) {
    //this.setState({ confirmAlldisabled: true })

    let request: any = {};
    request.CheckNos = checkno;

    request.bankid = bankid;
    request.Pvrno = 0;
    request.series = series;
    InvoiceService.UpdatePrintConfirm(request)
      .then(async (result: any | null) => {
        if (result.success) {
          this.closeSlideOut();


        }
        resolve();
      })
      .catch((error) => {
        this.setState({ confirmAlldisabled: false });
        toast.error("Something went wrong. " + error, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reject();
      });
  }

  redirectToReconciliation = () => {
    this.props.history.push({
      pathname: "/Reconcile",
      state: {
        bankId: this.state.formData.bankId,
        bankName: this.state.bankname,
        fromRegister: true,
      }
    });
  };
  closeInvoiceCheckslideout = () => {
    this.setState({ showInvoiceCheck: false, transactionId: 0 });
    this.getInvoiceListPaid(this.state.formData.bankId);
  };


  render() {
    const { permissions } = this.props; 
    const hasAddDepositPermission = permissions && permissions['Register'] ? permissions['Register'].includes('Add Deposit') : false;
    const hasAddWithdrawalPermission = permissions && permissions['Register'] ? permissions['Register'].includes('Add Withdrawal') : false;
    const hasAddTransferPermission = permissions && permissions['Register'] ? permissions['Register'].includes('Add Transfer') : false;

    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.invoiceListPaidPaid.filter((x) => x.rowType == 1 && x.entryType !== "J").length

      }] // A numeric array is also available. the purpose of above example is custom the text
    };




    const invoiceColumnsPaid = [
      {
        dataField: 'payDate',
        text: 'Date',
        sort: true,
        headerStyle: { width: '10%' },
        searchable: this.state.isdate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.payDate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'vendorCode',
        text: 'Code',
        sort: true,
        searchable: this.state.iscode,
        headerStyle: { width: '10%' },
      },

      {
        dataField: 'vendorName',
        text: 'Name',
        headerStyle: { width: '20%' },
        sort: true,
        searchable: this.state.isname,
      },
      {
        dataField: 'ckno',
        text: 'Type',
        headerClasses: 'text-center',
        classes: 'text-center',

        sort: true,
        searchable: this.state.isckno,
        headerStyle: { width: '10%' },
         formatter: (cell: any, row: any, rowIndex: any) => {
    let displayValue = row.ckno;

    if (row.ckno === 'DD') {
      displayValue = 'Deposit';
    } else if(row.ckno === 'WD'){
      displayValue = 'Withdrawal';
    }else if (row.ckno === 'TRF') {
      displayValue = 'Transfer';
    }

    return (
      <EllipsisWithTooltip placement="bottom">
         <span className="badge badge-pill badge-primary color-red">
        {displayValue}</span>
      </EllipsisWithTooltip>
    );
  },

      },

      {
        dataField: 'payment',
        text: 'Payment',
        headerClasses: 'text-end',
        classes: 'text-end pe-4 divred',
        sort: false,
        searchable: this.state.ispayment,
        headerStyle: { width: '15%' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.entryType == 'C' || row.entryType == 'TD' ? null : `${Utils.currencyFormat(row.payment)}`}
            </EllipsisWithTooltip>
          );
        },
          filterValue: (cell, row) => {
          return row.payment.toFixed(2);
        },
      },

      {
        dataField: 'deposit',
        text: 'Deposit',
        sort: false,
        searchable:this.state.isdeposit,
        headerClasses: 'text-end',
        classes: 'text-end pe-4 divgreen',
        headerStyle: { width: '15%' },
        //headerStyle: { width: '300px' },
        formatter: (cell: any, row: any, rowIndex: any) => {


          return (
            <EllipsisWithTooltip placement="bottom">

              {row.entryType == 'C' || row.entryType == 'TD'  || row.entryType == "P" ? `${Utils.currencyFormat(row.deposit)}` : null}
            </EllipsisWithTooltip>
          );
        },
          filterValue: (cell, row) => {
          return row.deposit.toFixed(2);
        },
      },




      {
        dataField: 'Balance',
        text: 'Balance',
        sort: false,
        searchable: false,
        //this.state.isdeposit,
        headerClasses: 'text-end',
        classes: 'text-end pe-4',
        headerStyle: { width: '15%' },
        //headerStyle: { width: '300px' },
        formatter: (cell: any, row: any, rowIndex: any) => {


          return (
            <EllipsisWithTooltip placement="bottom">

              { `${Utils.currencyFormat(row.balance)}`}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'cl',
        text: 'CL',
      },
      {
        dataField: 'adj',
        text: '',
        sort: true,
        searchable: this.state.isstatus,


        formatter: (cell: any, row: any, rowIndex: any) => {

          if (row.adj == "Yes") {
            return (
              <div>
                <h6>
                  {/* {row.status}  */}
                  
                   <span className="badge badge-pill badge-primary color-red">  Voided </span>
                </h6>
              </div>
            );
          }
         

        }
      },
       {
          dataField: 'invoiceNo',
          text: 'Inv / Ord No.',
          hidden:true,
          sort: false,
          headerStyle: { width: '100px' },
          searchable: this.state.isinvoiceno,
          classes: "expanding-bar btn-link",
        },
        {
          dataField: 'invoiceDate',
          text: 'Inv / Ord No.',
          hidden:true,
          sort: false,
          headerStyle: { width: '100px' },
          searchable: this.state.isinvoicedate,
          classes: "expanding-bar btn-link",
        },
        {
          dataField: 'invoiceStatus',
          text: '',
          hidden:true,
          headerStyle: { width: '100px' },
          searchable: this.state.isinvoicestatus,
          classes: "expanding-bar btn-link",
        },

   
    ];




    const selectOptions = [{
      id: 0, column: 'Vendor PO'
    },
    { id: 1, column: 'Vendor Code' },
    { id: 2, column: 'Vendor Name' },
    { id: 3, column: 'Order Date' },
    { id: 4, column: 'Status' },

    ];


    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderPreviousTableChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderPreviousTableChild = (mainrow) => {    
      debugger; 
      let invoiceListPaidPaidDetails: any = [];
      invoiceListPaidPaidDetails = this.state.invoiceListPaidPaid.filter(
        (x) => x.ckno === mainrow.ckno
         && x.rowType == 2 && x.vendorCode === mainrow.vendorCode
          && x.payDate === mainrow.payDate 
          && x.bankid === mainrow.bankid
          && x.series === mainrow.series
       && ((x.paymentMethod!="Check" && x.invoiceId === mainrow.invoiceId)
         || (x.paymentMethod=="Check" && 0== mainrow.invoiceId))
          //&& (x.paymentMethod == "Check" && (x.entryType == "I" || x.entryType == "C") ? true: x.invoiceId === mainrow.invoiceId)
      );

      // this.setState({ prevOrderidselected:  mainrow.orderID  });

      const invoiceColumnsPaidAll = [
         {
          dataField: 'loccode',
          text: 'Loc. Code',
          sort: true,
          // searchable: this.state.iscustomername,
          classes: "expanding-bar",
          // headerStyle: { width: '300px' },
        },
        {
          dataField: 'coa',
          text: 'COA',
          sort: true,
          searchable: this.state.iscustomername,
          classes: "expanding-bar",
          // headerStyle: { width: '300px' },
        },
        {
          dataField: 'coaname',
          text: 'COA Name',
          sort: true,
          searchable: this.state.iscustomername,
          classes: "expanding-bar",
          // headerStyle: { width: '300px' },
        },
        {
          dataField: 'invoiceNo',
          text: 'Inv No.',
          sort: true,
          headerStyle: { width: '100px' },
          searchable: true,
          classes: "expanding-bar btn-link",
        },
         {
          dataField: 'invoiceStatus',
          text: 'Inv Status',
          sort: true,
          headerStyle: { width: '150px' },
          searchable: true,
          classes: "expanding-bar",
        },
        {
          dataField: 'invoiceDate',
          text: 'Inv Date',
          sort: true,
          classes: "expanding-bar",
          headerStyle: { width: '100px' },
          searchable: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {/* {row.invoiceDate == null || row.invoiceDate == undefined ? "" : moment(row.invoiceDate).format("MM/DD/YYYY")} */}
                {row.invoiceDate == null || row.invoiceDate == undefined ? "" : row.invoiceDate}

              </EllipsisWithTooltip>
            );
          },
        },
        // {
        //   dataField: 'vendorName',
        //   text: 'Vendor Name',
        //   sort: true,
        //   searchable: this.state.iscustomername,
        // },
        {
          dataField: 'accountingPeriod',
          text: 'Accounting Period',
          sort: true,
          searchable: this.state.iscustomername,
          classes: "expanding-bar",
          // headerStyle: { width: '300px' },
        },

        // {
        //   dataField: 'dueDate',
        //   text: 'Due Date',
        //   sort: true,
        //   classes: "expanding-bar",
        //   headerStyle: { width: '100px' },
        //   searchable: this.state.isorderdate,
        //   formatter: (cell: any, row: any, rowIndex: any) => {
        //       return (
        //         <EllipsisWithTooltip placement="bottom">
        //       {/* {row.dueDate ? (row.entryType === "P" ? row.dueDate : moment(row.dueDate).format("MM/DD/YYYY")) : ""}               */}
        //       {row.dueDate ? row.dueDate : ""}
        //       </EllipsisWithTooltip>
        //       );
        //   },
        // },

        {
          dataField: 'amount',
          text: 'Amount',
          headerClasses: 'text-end',
          classes: 'text-end pe-4 expanding-bar',
          sort: true,
          searchable: false,
          headerStyle: { width: '100px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.amount)}
              </EllipsisWithTooltip>
            );
          },
        },




      ];

      return (
        <>
          <div className='px-4 p-4'>
            <BootstrapTable
              id="tblCOAchild"
              keyField="uniqueNo"
              data={invoiceListPaidPaidDetails}
              columns={invoiceColumnsPaidAll}
              rowEvents={this.rowEvents}
            // selectRow={ selectRow }
            //  onClick={(e) => this.handleRowSelectionCheck(e, rowIndex,row.orderID,"no")}
            />
          </div>
        </>
      );
    };
    const {

      showSlideout,
      showInvoiceSlideout,
      showReceivableslideout,
      openDeposit,
      openWithdrawal,
      openTransfer,
      openJournal
    } = this.state;









    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex  ">

              Register
              <div className="col" style={{ position: 'fixed', right: '100px' }}>
                <div className="d-flex justify-content-end align-items-center gap-3">

                  <Button
                    className="addNewVendor"
                    id="saveBtn"
                    tabIndex={15}
                    onClick={() => this.redirectToReconciliation()}
                  >
                    Reconcile
                  </Button>
                  <Dropdown
                    className="more-action"
                    onSelect={(event) => { this.moreOptions(event); }}
                  >

                    <Dropdown.Toggle className="addNewVendor">
                      Add Transaction
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                    {hasAddDepositPermission && <Dropdown.Item eventKey="deposit">Deposit</Dropdown.Item>}
                    {hasAddWithdrawalPermission && <Dropdown.Item eventKey="withdrawal">Withdrawal</Dropdown.Item>}
                    {hasAddTransferPermission && <Dropdown.Item eventKey="transfer">Transfer</Dropdown.Item>}
                    </Dropdown.Menu>
                  </Dropdown>

                </div>
              </div>

              <div className="col" style={{ position: 'fixed', right: '50px' }}>
                <div className="action">



                  <Dropdown
                    className="more-action"

                    onSelect={(event: any) => { this.moreOptions(event); }}
                  >

                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>

                      <Dropdown.Item
                        // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                        eventKey={"Print"}
                        key={1}
                      >
                        {"Print"}
                      </Dropdown.Item>


                    </Dropdown.Menu>
                  </Dropdown>

                </div>
              </div>
            </div>
            <section className="mt-3">

              <ToolkitProvider
                keyField="id"
                data={this.state.invoiceListPaidPaid.filter((x) => x.rowType == 1 && x.entryType !== "J")}
                columns={invoiceColumnsPaid}
                search
              >
                {
                  props => (




                    <div >
                      <section className="d-flex flex-wrap gap-2 pb-2">

                        <div className="col-12 col-md-2" style={{ marginTop: '6px' }}
                        >
                          <Form.Group controlId="buyerName">
                            <div className="parent my-data">
                            {/* <FontAwesomeIcon icon={faBuildingColumns} /> */}
                            
                              <div className="w-auto">
                                  {this.state.bankList.length > 0 && (

                                    <SingleDropdownListWithoutSearch
                                      tabIndex={this.state.tabEnable}
                                      itemList={this.state.bankList}
                                      handleSelectedItem={this.handleSelectedItem2.bind(
                                        this,
                                        2
                                      )}
                                      defaultItem={this.state.formData.bankname}
                                      defaultText={"Select Account"}
                                      defaultName={this.state.bankname}
                                      controlID="1"
                                      id={"ddlBank"}
                                      isBank={true}
                                    />
                                  )}
                              </div>
                            </div>
                          </Form.Group>
                        </div>
                      </section>


                      <section className="d-flex flex-wrap gap-2 pb-2">

{/* 
                        <div className="col-12 col-md-2 position-relative" style={{ marginTop: '6px' }}
                        >
                          <SearchBar {...props.searchProps} />
                        </div> */}

                         <div
                          className="col-12 col-md-2 position-relative"
                          style={{ marginTop: '6px' }}
                        >
                          <div style={{ position: "relative", width: "100%" }}>
                            <SearchBar
                              {...props.searchProps}
                              className="form-control"
                              placeholder="Search..."
                              style={{
                                width: "100%",
                                paddingRight: "30px",
                              }}
                            />

                            {props.searchProps.searchText && props.searchProps.searchText.trim() !== "" && (
                              <button
                                type="button"
                                className="btn-clear-search"
                                onClick={() => props.searchProps.onSearch("")}
                                title="Clear search"
                              >
                                ×
                              </button>
                            )}
                          </div>
                        </div>

                        <div
                          className='col-12 col-md-2 pe-2'
                          style={{ marginTop: '6px' }}
                        //className="input-group w-auto"
                        >
                            <SingleDropdownListWithoutSearch

                              itemList={this.state.selectOptions}
                              handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                              defaultItem={this.state.selectedcolumn}
                              defaultText={"Select Filter"}
                              defaultName={this.state.selectedcolumn}
                              controlID="1"
                              id={"ddlselected"}

                            />
                        </div>

                        <div className="col-12 col-md-5" >
                          <DateRange onDateRangeChange={this.handleDateRangeChange}  ></DateRange>
                        </div>
                      
                      {this.state.IsDateRange && (
                          <div className="col-12 col-md-1" style={{ marginTop: '6px', marginLeft: "10px" }}>
                          <Button
                            onClick={this.handleSearch}
                          >Search</Button>
                        </div>


                      )}
                      

                      </section>
                      <section className="pb-3">
                        <div className="table-responsive divbottom"  >
                          <div className="ml-auto transactions-list expand-tbl">
                            <BootstrapTable
                              id="tblInvoice"
                              {...props.baseProps}
                              keyField="id"
                              expandRow={expandSplitRow}
                              rowEvents={this.rowEvents1}
                              pagination={paginationFactory(options)}
                              rowClasses={(row, rowIndex) =>
                                  row.rowType == 1 && row.entryType !== "J" ? "main-row" : "expand-row"
                                }
                            />
                          </div>
                        </div>
                      </section>
                    </div>

                  )
                }
              </ToolkitProvider>

            </section>



            {(showInvoiceSlideout &&
              <InvoiceEntryslideout
                closeSlideOut={this.closeInvoiceSlideOut}
                orderIds={this.state.orderIds}
                invoiceId={this.state.invoiceId}
              >


              </InvoiceEntryslideout>
            )}

            {(showReceivableslideout &&
              <Receivableslideout
                closeSlideOut={this.closeInvoiceSlideOut}
                orderid={this.state.orderid}
                orderIds={this.state.orderIds}
                products={this.state.products}
                invoiceId={this.state.invoiceId}
              >


              </Receivableslideout>
            )}

            {openDeposit &&
              <DepositSlideout transactionID={this.state.transactionId} bankId={this.state.formData.bankId} bankname={this.state.bankname} closeSlideOut={this.closeDepositslideout} />
            }

            {openWithdrawal &&
              <WithdrawalSlideout transactionID={this.state.transactionId} bankId={this.state.formData.bankId} bankname={this.state.bankname} closeSlideOut={this.closeWithdrawalslideout} />
            }

            {openJournal &&
              <JournalSlideout journalEntryID={this.state.transactionId} closeSlideOut={this.closeJournalslideout} />
            }


            {openTransfer &&
              <TransferSlideout transferID={this.state.transferId}  bankId={this.state.formData.bankId} bankname={this.state.bankname} closeSlideOut={this.closeTransferslideout} />}

            {this.state.showInvoice &&
              <InvoiceSlideout transactionID={this.state.invoiceId} closeSlideOut={this.closeInvoiceslideout} />}

            {this.state.showInvoiceCheck && (
              <InvoiceCheckSlideout
                transactionID={this.state.invoiceId}
                closeSlideOut={this.closeInvoiceCheckslideout}
                ckno={this.state.ckno}
                bankid={this.state.bankid}
                series={this.state.series}
                ckdate={this.state.ckdate}
              />
            )}
          </Container>


          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId  
});

export default connect(mapStateToProps)(Register);